import { red } from '@mui/material/colors';
import * as actionTypes from '../actions/actionTypes';

const currentDarkMode = JSON.parse(localStorage.getItem('isDarkMode'));

const initalState = {
	typography: {
		fontFamily: [
			'-apple-system',
			'BlinkMacSystemFont',
			'Segoe UI',
			'Roboto',
			'Helvetica',
			'Arial',
			'sans-serif',
			'Apple Color Emoji',
			'Segoe UI Emoji',
			'Segoe UI Symbol'
		].join(',')
	},
	isDarkMode: false,
	palette: {
		mode: currentDarkMode ? 'dark' : 'light',
		primary: {
			main: currentDarkMode ? '#EF9300' : 'rgba(19,66,111,1)',
			mainHover: currentDarkMode ? 'rgb(239,146,0.8)' : 'rgba(19,66,111,0.9)',
			light: 'rgba(10, 57, 129, 0.03)',
			hover: 'rgba(10, 57, 129, 0.08)'
		},
		secondary: {
			main: currentDarkMode ? 'rgba(19,66,111,1)' : '#EF9300',
			light: 'rgba(10, 57, 129, 0.2)'
		},
		background: {
			image: 'none',
			paper: currentDarkMode ? 'rgba(19,66,111,1)' : '#fff'
		},
		backgroundColor: '#fff',
		error: red,
		contrastThreshold: 3,
		tonalOffset: 0.2
	},
	shape: {
		borderRadius: 25
	},
	shadows: ['none', ...Array(24).fill('rgba(0, 0, 0, 0.1) 0px 4px 12px;')],
	components: {
		MuiCssBaseline: {
			styleOverrides: {
				'*': {
					scrollbarWidth: 'thin',
					scrollbarColor: '#b0b0b0 transparent' // Thumb color with transparent track
				},
				'*::-webkit-scrollbar': {
					width: '8px',
					height: '8px',
					backgroundColor: 'transparent' // Transparent track
				},
				'*::-webkit-scrollbar-thumb': {
					backgroundColor: '#b0b0b0', // Thumb color
					borderRadius: '8px', // Rounded corners for the thumb
					border: '2px solid transparent' // Transparent padding between thumb and track
				},
				'*::-webkit-scrollbar-thumb:hover': {
					backgroundColor: '#8a8a8a' // Slightly darker thumb on hover
				},
				'*::-webkit-scrollbar-track': {
					backgroundColor: 'transparent' // Fully transparent track
				}
			}
		},
		MuiDialog: {
			styleOverrides: {
				paper: {
					backgroundImage: 'none'
				}
			}
		}
	}
};
const toggleDarkMode = (state, action) => {
	return { ...state };
};

const reducer = (state = initalState, action) => {
	switch (action.type) {
		case actionTypes.TOGGLE_DARKMODE:
			return toggleDarkMode(state, action);
		default:
			return state;
	}
};

export default reducer;
